/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForInboundPictureNoDataVo
 */
export interface OrderInfoForInboundPictureNoDataVo {
    /**
     * 无数据信息id
     * @type {number}
     * @memberof OrderInfoForInboundPictureNoDataVo
     */
    noDataId?: number;
    /**
     * 区域
     * @type {string}
     * @memberof OrderInfoForInboundPictureNoDataVo
     */
    zone?: string;
    /**
     * 库位
     * @type {string}
     * @memberof OrderInfoForInboundPictureNoDataVo
     */
    locationNo?: string;
}

/**
 * Check if a given object implements the OrderInfoForInboundPictureNoDataVo interface.
 */
export function instanceOfOrderInfoForInboundPictureNoDataVo(value: object): value is OrderInfoForInboundPictureNoDataVo {
    return true;
}

export function OrderInfoForInboundPictureNoDataVoFromJSON(json: any): OrderInfoForInboundPictureNoDataVo {
    return OrderInfoForInboundPictureNoDataVoFromJSONTyped(json, false);
}

export function OrderInfoForInboundPictureNoDataVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForInboundPictureNoDataVo {
    if (json == null) {
        return json;
    }
    return {
        
        'noDataId': json['noDataId'] == null ? undefined : json['noDataId'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
    };
}

export function OrderInfoForInboundPictureNoDataVoToJSON(json: any): OrderInfoForInboundPictureNoDataVo {
    return OrderInfoForInboundPictureNoDataVoToJSONTyped(json, false);
}

export function OrderInfoForInboundPictureNoDataVoToJSONTyped(value?: OrderInfoForInboundPictureNoDataVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'noDataId': value['noDataId'],
        'zone': value['zone'],
        'locationNo': value['locationNo'],
    };
}

